export default __webpack_public_path__ + "static/media/Page27.d1dd72d1.txt";